import React from 'react';

import dayjs from "dayjs";

import {CircularProgress, LinearProgress, Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";

import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommonForm from "../Common/CommonForm";
import {customRange, findArrayItemsByKeyValue, splitToList} from "../../utils/misc";
import BaseApi from "../../utils/BaseApi";
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";
import Link from "@mui/joy/Link";
import {generatePath} from "react-router-dom";


class FinancialModelLaborForecast extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            report: null,
            opportunityReport: null,
            subscriberReport: null,
            roleField: null,
        }
    }

    async componentDidMount() {
        await this.retrieveData();
    }

    async retrieveData() {
        const api = new BaseApi();
        let url = 'opp_team/create_form'
        let params = {
            fields: JSON.stringify(
                ['role']
            )
        };
        let response = await api.get(
            url,
            params,
        );
        let roleField = response.data[0]
        roleField.type = 'multiselect-inline'
        roleField.default = ['R', ]
        roleField.md = 6
        if (roleField) {
            this.setState(
                {
                    roleField: roleField,
                }
            )
        }
    }

    async processForm(form) {
        let today = dayjs()
        const api = new BaseApi();
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        if ('statuses' in formDataObj) {
            formDataObj.statuses = splitToList(formDataObj.statuses, ',')
        } else {
            formDataObj.statuses = []
        }
        if ('role' in formDataObj) {
            formDataObj.role = splitToList(
                formDataObj.role,
                ','
            )
        } else {
            formDataObj.role = []
        }
        let report = {}
        let opportunityReport = {}
        let subscriberReport = {}
        for (let status of formDataObj.statuses) {
            let url = 'opportunity/report/';
            let params = {
                status: status,
                xtypes: formDataObj.xtypes,
                cards: true,
            }
            let response = await api.get(
                url,
                params
            );
            let cards = response.data.cards
            for (let opportunity of response.data.report) {
                let opportunityCard = findArrayItemsByKeyValue(
                    cards,
                    'opportunity.id',
                    opportunity[0]
                )
                if (opportunityCard.length){
                    opportunityCard = opportunityCard[0]
                }
                else {
                    opportunityCard = null
                }
                let opportunityData = {
                    color: opportunity[2],
                    card: opportunityCard,
                }
                let url = `certificate/`;
                let response = await api.get(
                    url,
                    {
                        opportunity: opportunity[0],
                    }
                );
                if (response.data.results.length) {
                    opportunityData.endDate = dayjs(response.data.results[response.data.results.length - 1].date)
                    opportunityData.certificate = true
                } else {
                    opportunityData.certificate = false
                    let forecastRevenues = findArrayItemsByKeyValue(
                        this.props.forecastRevenues,
                        'opportunity.id',
                        opportunity[0]
                    )
                    if (forecastRevenues.length) {
                        opportunityData.endDate = dayjs(forecastRevenues[0].date)
                    }
                    else {
                        opportunityData.endDate = null
                    }
                }
                if (opportunityData.endDate && opportunityData.endDate > today){
                    opportunityData.value = opportunityData.endDate.month() - today.month()
                    if (opportunityData.endDate.month() < today.month()){
                        opportunityData.value += 12
                    }
                    if (opportunityData.endDate.year() > today.year() && opportunityData.endDate.month() === today.month()){
                        opportunityData.value = 12
                    }
                    if (opportunityData.endDate.year() > today.year() && opportunityData.endDate.month() > today.month()){
                        opportunityData.value = 13
                    }
                    opportunityData.value += 0.01
                }
                else {
                    opportunityData.value = 0
                }
                opportunityReport[opportunity[0]] = opportunityData
                url = `opp_team/`;
                response = await api.get(
                    url,
                    {
                        opportunity: opportunity[0],
                        active: true,
                    }
                );
                for (let teamMate of response.data.results) {
                    subscriberReport[teamMate.subscriber.id] = teamMate.subscriber
                    if (formDataObj.role.includes(teamMate.role) && opportunityData.value) {
                        let bubbleData = {
                            opportunity: opportunity[0],
                            role: teamMate.role
                        }
                        if (teamMate.subscriber.id in report) {
                            report[teamMate.subscriber.id].push(
                                bubbleData
                            )
                        } else {
                            report[teamMate.subscriber.id] = [bubbleData,]
                        }
                    }
                }
            }
        }
        this.setState(
            {
                report: report,
                opportunityReport: opportunityReport,
                subscriberReport: subscriberReport,
            }
        )
    }

    render() {
        let today = dayjs()
        if (!this.state.roleField) {
            return (
                <CircularProgress/>
            )
        }
        let roles = {}
        for (let role of this.state.roleField.options){
            roles[role.value] = role.label
        }
        return (
            <Stack>
                <CommonForm
                    processForm={this.processForm.bind(this)}
                    fields={[
                        {
                            name: 'statuses',
                            label: 'Статусы сделки',
                            xs: 12,
                            sm: null,
                            md: 6,
                            lg: null,
                            xl: null,
                            required: true,
                            default: ['OPENX',],
                            type: 'multiselect-inline',
                            options: [
                                {'value': 'OPENX', 'label': 'В работе'},
                                {'value': 'DELAY', 'label': 'Ожидает'},
                                {'value': 'CLOSE', 'label': 'Закрыта'},
                                {'value': 'LOSTX', 'label': 'Потеряна'},
                            ]
                        },
                        {
                            'name': 'xtypes',
                            'label': 'Типы процессов',
                            'xs': 12,
                            'sm': null,
                            'md': 6,
                            'lg': null,
                            'xl': null,
                            'required': false,
                            'default': ['report', ],
                            'type': 'multiselect-inline',
                            'options': this.props.xtypeChoices.map((each) => {
                                return (
                                    {
                                        'value': each[0],
                                        'label': each[1]
                                    }
                                )
                            })
                        },
                        this.state.roleField,
                        {
                            'type': 'submit',
                            'label': 'Отобрать'
                        }
                    ]}
                />
                {
                    this.state.subscriberReport && this.state.opportunityReport && this.state.report ?
                        <Stack
                            direction={'row'}
                            spacing={2}
                        >
                            <Stack
                                spacing={2}
                            >
                                <Chip>
                                    Сотрудник
                                </Chip>
                                {
                                    Object.keys(this.state.report).map(
                                        (key) => (
                                            <Stack
                                                spacing={1}
                                            >
                                                <ProfileHorizontalByProps
                                                    user={this.state.subscriberReport[key].user}
                                                />
                                                {this.state.report[key].length>1?customRange(1,this.state.report[key].length-1,1).map((e)=>(<Chip sx={{backgroundColor: 'transparent'}}></Chip>)):null}
                                            </Stack>
                                        )
                                    )
                                }
                            </Stack>
                            <Stack
                                sx={{
                                    flexGrow: 2
                                }}
                                spacing={2}
                            >
                                <Stack
                                    direction={'row'}
                                    spacing={2}
                                    sx={{
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                        position: 'sticky',
                                        top: '0',
                                        zIndex: 1003,
                                    }}
                                >
                                    {
                                        customRange(today.month(), today.month() + 12, 1).map(
                                            (m) => {
                                                if(m > 11){
                                                    return(
                                                        <Chip sx={{m: 0}}>
                                                            {m - 11}.{today.year() + 1}
                                                        </Chip>
                                                    )
                                                }
                                                else {
                                                    return(
                                                        <Chip sx={{m: 0}}>
                                                            {m + 1}.{today.year()}
                                                        </Chip>
                                                    )
                                                }
                                            }
                                        )
                                    }
                                </Stack>
                                {
                                    Object.keys(this.state.report).map(
                                        (key) => (
                                            <Stack
                                                spacing={1}
                                            >
                                                {
                                                    this.state.report[key].map(
                                                        (bubble) => {
                                                            let value = this.state.opportunityReport[bubble.opportunity].value * 7.69 + 3.84
                                                            if (value > 100){
                                                                value = 100
                                                            }
                                                            return(
                                                                <LinearProgress
                                                                    determinate
                                                                    value={value}
                                                                    color={
                                                                        this.state.opportunityReport[bubble.opportunity].certificate?'success':'warning'
                                                                    }
                                                                    sx={{
                                                                        minHeight: '24px'
                                                                    }}
                                                                    size={'lg'}
                                                                    thickness={18}
                                                                >
                                                                    <Typography
                                                                        level="body-xs"
                                                                        sx={{
                                                                            zIndex: 1001,
                                                                            color: '#FFF'
                                                                        }}
                                                                    >
                                                                        <Link
                                                                            href={generatePath('/opportunity/detail/:id', {id: bubble.opportunity})}
                                                                            target={'_blank'}
                                                                            noWrap
                                                                            sx={{
                                                                                color: '#FFF',
                                                                                textDecoration: 'underline'
                                                                            }}
                                                                        >
                                                                            {this.state.opportunityReport[bubble.opportunity].card.opportunity.short_name}
                                                                        </Link> - {roles[bubble.role]}
                                                                    </Typography>
                                                                </LinearProgress>
                                                            )
                                                        }
                                                    )
                                                }
                                            </Stack>
                                        )
                                    )
                                }
                            </Stack>
                        </Stack> :
                        <Typography>
                            Выберите параметры и сгенерируйте отчет
                        </Typography>
                }
            </Stack>
        )
    }
}

export default FinancialModelLaborForecast
